import { render } from "./VueTWfooter.vue?vue&type=template&id=b97c793e"
const script = {}
script.render = render

export default script